"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactParticlesJs = _interopRequireDefault(require("react-particles-js"));

var _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed"));

var _projectTypes = _interopRequireDefault(require("../constants/projectTypes"));

require("../styles/_create-video.scss");

var _particles = _interopRequireDefault(require("../constants/particles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function buildCardImageProps(type) {
  return {
    backgroundSize: 'cover',
    imageElement: {
      sourceUrl: "https://hubdatastore-shootsta-sydney-defaultp.s3-ap-southeast-2.amazonaws.com/global/images/".concat(type),
      alt: type,
      sourceExtension: 'jpg'
    }
  };
}

var CreateVideo = /*#__PURE__*/function (_Component) {
  _inherits(CreateVideo, _Component);

  var _super = _createSuper(CreateVideo);

  function CreateVideo(props) {
    var _this;

    _classCallCheck(this, CreateVideo);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onUpdateName", function (_ref) {
      var value = _ref.target.value;

      _this.setState({
        name: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var onSave, _this$state, name, projectType;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              onSave = _this.props.onSave;
              _this$state = _this.state, name = _this$state.name, projectType = _this$state.projectType;

              if (name) {
                onSave({
                  name: name,
                  projectType: projectType
                });
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "selectType", function (type) {
      return function () {
        var projectType = _this.state.projectType;

        if (projectType === type) {
          return;
        }

        _this.setState({
          projectType: type
        });
      };
    });

    _this.state = {
      // settingsEnabled: false,
      name: '',
      projectType: 'VIDEO'
    };
    return _this;
  }

  _createClass(CreateVideo, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          name = _this$state2.name,
          projectType = _this$state2.projectType;
      var _this$props = this.props,
          history = _this$props.history,
          saving = _this$props.saving;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "create-video page--no-padding"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.PageHeader, {
        title: "Create Project",
        breadCrumbs: [{
          title: 'Home',
          url: '/'
        }, {
          title: 'Projects',
          url: '/video-tool'
        }]
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "create-video__content-container"
      }, /*#__PURE__*/_react.default.createElement(_reactParticlesJs.default, {
        width: "100%",
        height: "100%",
        className: "create-video__content-container__background",
        params: _particles.default
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "create-video__content column"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "create-video__content__settings"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "create-video__content__input",
        onChange: this.onUpdateName,
        value: name,
        placeholder: "Enter project name",
        onKeyDown: (0, _onEnterPressed.default)({
          onClick: this.onSave,
          allowPropagation: true
        })
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "create-video__content__type-header",
        heading4: true,
        centered: true
      }, "What type of project do you want to create?")), /*#__PURE__*/_react.default.createElement("div", {
        className: "create-video__content__types"
      }, Object.entries(_projectTypes.default).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            type = _ref4[0],
            display = _ref4[1];

        return /*#__PURE__*/_react.default.createElement(_uiKit.List.CardItem, {
          className: (0, _classnames.default)('create-video__content__types__card', {
            'create-video__content__types__card--selected': type === projectType
          }),
          onClick: _this2.selectType(type),
          smallCoverImage: true,
          coverImageProps: buildCardImageProps(display.imageKey)
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
          noMargin: true,
          highlighted: type === projectType
        }, display.label), /*#__PURE__*/_react.default.createElement(_uiKit.RadioButton, {
          darkMode: true,
          selected: type === projectType
        }));
      })))), /*#__PURE__*/_react.default.createElement(_commonReact.NavigationFooter, {
        primaryButtonText: "Continue",
        secondaryButtonText: "Cancel",
        onClickSecondary: history.goBack,
        onClickPrimary: this.onSave,
        primaryButtonBusy: saving,
        primaryButtonDisabled: !name
      }));
    }
  }]);

  return CreateVideo;
}(_react.Component);

exports.default = CreateVideo;